document.addEventListener("turbolinks:load", function () {
  if($('#fisical-exam-form').length) {
    mitralBlowSetup();
    tricuspideBlowSetup();
  }
})

// note: maybe this logic could be extracted to a class specialized on set this kind of interaction.
// Config previously castrated iteractios.
function mitralBlowSetup() {
  $('#vet_fisical_exam_mitral_blow_true').on('click', () => {
    $('#div-mitral-blow-degree').removeAttr('hidden')
  })

  $('#vet_fisical_exam_mitral_blow_false').on('click', () => {
    $('#div-mitral-blow-degree').attr('hidden', 'true')
  })
}

function tricuspideBlowSetup() {
  $('#vet_fisical_exam_tricuspide_blow_true').on('click', () => {
    $('#div-tricuspide-blow-degree').removeAttr('hidden')
  })

  $('#vet_fisical_exam_tricuspide_blow_false').on('click', () => {
    $('#div-tricuspide-blow-degree').attr('hidden', 'true')
  })
}
